import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import { computeHeight } from '../utils/animationUtils';

import styles from './Collapse.scss';

const transitionClasses = {
    enter: styles.enter,
    enterActive: styles.enterActive,
    enterDone: styles.enterDone,
    exit: styles.exit,
    exitActive: styles.exitActive,
    exitDone: styles.exitDone,
};

class Collapse extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        id: PropTypes.string,
        duration: PropTypes.number,
        isOpen: PropTypes.bool,
        appear: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        duration: 750,
        appear: false,
    };

    constructor(props) {
        super(props);

        const setToAuto = !this.props.appear && this._shouldShow();
        this.state = {
            height: setToAuto
                ? 'auto'
                : 0,
        };

        this._childRef = React.createRef();
    }

    _setHeight = () => {
        const height = computeHeight(this._childRef);
        this.setState(() => ({ height }));
    }

    _setHeightAuto = () => {
        this.setState(() => ({ height: 'auto' }));
    }

    _setHeightToZero = () => {
        this.setState(() => ({ height: 0 }));
    }

    _shouldShow() {
        const {
            in: transitionIn,
            isOpen,
        } = this.props;

        if (typeof isOpen !== 'undefined') {
            return isOpen;
        }

        return transitionIn;
    }

    render() {
        const {
            children,
            className,
            childClassName,
            duration,
            isOpen: _isOpen,
            id,
            ...transitionProps
        } = this.props;
        const { height } = this.state;

        const shouldShow = this._shouldShow();
        return (
            <CSSTransition
                {...transitionProps}
                classNames={transitionClasses}
                in={shouldShow}
                onEnter={this._setHeight}
                onEntered={this._setHeightAuto}
                onExit={this._setHeight}
                onExiting={this._setHeightToZero}
                timeout={duration}
            >
                {(transitionState) => {
                    const isHidden = transitionState === 'exited';

                    return (
                        <div
                            className={classNames(className, styles.collapse)}
                            id={id}
                            style={{
                                transitionDuration: `${duration}ms`,
                                height,
                            }}
                        >
                            <div
                                className={classNames(
                                    styles.child,
                                    childClassName,
                                    { [styles.hidden]: isHidden },
                                )}
                                ref={this._childRef}
                            >
                                {children}
                            </div>
                        </div>
                    );
                }}
            </CSSTransition>
        );
    }
}

export default Collapse;
